import '@backstage/cli/asset-types';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// Backstage UI (BUI) design-system stylesheet: defines --bui-* variables and
// the layout for BUI-based components like AboutContent. Missing it collapses
// those grids to a vertical stack. Must load before index.css overrides.
import '@backstage/ui/css/styles.css';
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
